/* eslint-disable no-param-reassign */
export default {
  state: {
    dataset: [],
    queryMsg: {
      keyword: '', // 搜索
      sort_rule: 'update_time_sort'
    },
    modelView: 'table',
    iconList: [
      {
        icon: 'iconicon_bulletin_board',
        components: 'Board',
        key: 1,
        text: '看板'
      },
      {
        icon: 'iconicon_tabulation',
        components: 'TableNew',
        key: 2,
        text: '列表'
      },
      {
        icon: 'iconicon_gantt_chart_chart',
        components: 'Gantt',
        key: 3,
        text: '甘特图'
      }
    ]
  },
  mutations: {
    set_data: (state, data) => {
      state.dataset = data
    },
    set_keyword: (state, data) => {
      state.queryMsg.keyword = data
    },
    set_sort_rule: (state, data) => {
      state.queryMsg.sort_rule = data
    },
    set_mod_view: (state, data) => {
      state.modelView = data
    },
    clear_queryMsg: (state, data) => {
      state.queryMsg = {
        keyword: '', // 搜索
        sort_rule: 'update_time_sort'
      }
      state.modelView = 'table'
    },
    set_taskModeCheck: (state, data) => {
      state.dataset.default_view = state.iconList[data]?.key
    },
    task_del: (state, id) => {
      if (!id) return console.log('没有ID')
      state.dataset.project_template_content.task_list.find((res) => {
        let arr = res.tasks.find((temp, index) => {
          if (temp.id === id) {
            res.tasks.splice(index, 1)
            return true
          }
          if (temp.children) {
            let data = temp.children.find((child, index) => {
              if (child.id === id) {
                temp.children.splice(index, 1)
                return true
              }
            })
            if (data) {
              return true
            }
          }
        })
        if (arr) return arr
      })
    },
    task_add: (state, data) => {
      if (!data) return console.log('没有ID')
      let { pid, task_list_id, dataset } = data
      state.dataset.project_template_content.task_list.find((res) => {
        if (res.id === task_list_id && (!pid || pid === '' || pid === 0)) {
          res.tasks.unshift(dataset)
          return true
        } else if (res.id === task_list_id) {
          return res.tasks.find((res) => {
            if (res.id === pid) {
              res.children.unshift(dataset)
              return true
            }
          })
        }
      })
    },
    task_update_id: (state, dataset) => {
      if (!dataset) return console.log('没有ID')
      state.dataset.project_template_content.task_list.find((res) => {
        let result = res.tasks.find((temp, index) => {
          if (temp.id === dataset.id) {
            res.tasks.splice(index, 1, dataset)
            console.log(res.tasks, dataset)
            return temp
          }
          if (temp.children) {
            let data = temp.children.find((child, index) => {
              if (child.id === dataset.id) {
                temp.children.splice(index, 1, dataset)
                return true
              }
            })
            if (data) {
              return data
            }
          }
        })
        if (result) {
          return result
        }
      })
    }
  },
  getters: {},
  actions: {
    task_find_id: ({ state }, id) => {
      if (!id) return console.log('没有ID')
      let findItem = {}
      state.dataset.project_template_content.task_list.find((res) => {
        let arr = res.tasks.find((temp) => {
          if (temp.id === id) {
            findItem = JSON.parse(JSON.stringify(temp))
            return temp
          }
          if (temp.children) {
            let data = temp.children.find((child) => {
              if (child.id === id) {
                return child
              }
            })
            if (data) {
              findItem = JSON.parse(JSON.stringify(data))
              return data
            }
          }
        })
        if (arr) {
          return arr
        }
      })
      console.log('----ggg----------', findItem)
      return findItem
    }
  }
}
